import { Helper } from "../../util/helper.js";
import React from "react";
export default class GridDetails extends React.Component<{
    columns: any;
    dataItem: any;
    visible: boolean;
    children?: React.ReactNode;
}, any> {

    constructor(props) {
        super(props);
    }

    private getMobileItemTemplate = (kendoColumns: any[], row) => {
        const getTemplate = function (column: any) {
            let template = column.template;
            let format = column.format;
            let value = `#=data.${column.field} ?? ''#`;
            if (typeof template == "function")
                value = template(row);
            else if (template)
                value = template;
            else if (format)
                value = `#=kendo.format("${format}", data.${column.field})#`;

            return value;
        }

        if (!row || Array.isArray(row))
            return null;

        let templates: JSX.Element[] = [];
        for (let kendoColumn of kendoColumns) {
            if (!Helper.hasValue(kendoColumn.title))
                continue;
            let columnTemplate = kendo.template(getTemplate(kendoColumn))(row);
            templates.push(<div className="grid-details__item" key={"gridDetails_" + kendoColumn.field}>
                <div className='grid-details__title'>{kendoColumn.title}</div>
                <div className='grid-details__template' dangerouslySetInnerHTML={{ __html: columnTemplate }}></div>
            </div>);
        }

        return <div className={"grid-details"}>{templates}</div>;
    }

    render() {
        if (!this.props.visible)
            return null;

        let template = this.getMobileItemTemplate(this.props.columns, this.props.dataItem);
        return <div className={"grid-details-container grid-details-container--grid"}>
            <div className={"grid-details__children-container"} style={{ display: this.props.children ? "block" : "none" }}>
                {this.props.children}
            </div>
            {template}
        </div>
    }
}